import React, { memo } from 'react';
import { Toaster as SonnerToaster, } from 'sonner';
import styles from './Toaster.module.scss';
import { AlertErrorIcon, AlertWarningIcon, AlertSuccessIcon, AlertInfoIcon, } from '../SvgIcons';
import { Loader } from 'components/Loader';
export { toast } from 'sonner';
const theme = {
    toast: styles.toast,
    success: styles.success,
    warning: styles.warning,
    info: styles.info,
    error: styles.error,
    default: styles.default,
    icon: styles.icon,
};
const options = {
    classNames: theme,
    unstyled: true,
};
const icons = {
    error: React.createElement(AlertErrorIcon, { color: "#ffffff" }),
    success: React.createElement(AlertSuccessIcon, { color: "#ffffff" }),
    info: React.createElement(AlertInfoIcon, { color: "#ffffff" }),
    warning: React.createElement(AlertWarningIcon, { color: "#ffffff" }),
    loading: (React.createElement(Loader, { className: styles.loader, isShow: true, smallLoader: true })),
};
export const Toaster = memo(() => (React.createElement(SonnerToaster, { position: "top-center", icons: icons, toastOptions: options })));
